export default __webpack_public_path__ + "static/media/verify_device_lock.39772bf5.png";